const SampleSearches = [
  "How has music evolved over time? 🎹",
  "What happened before the Big Bang? 💥",
  "How will artificial intelligence impact society? 🤖",
  "Classes about how algorithms shape politics and society",
  "Courses that connect climate change, economics, and public policy",
  "Beginner-friendly data science with real-world projects",
  "I want to understand misinformation, social media, and democracy",
  "Classes about cities, transportation, and the built environment",
  "Courses on neuroscience, psychology, and human behavior",
  "How do diseases spread, and how should public health respond?",
  "Classes about medical ethics, biotechnology, and society",
  "Courses that mix music, technology, and creativity",
  "I like philosophy and AI; what should I take?",
  "Classes about law, privacy, surveillance, and technology",
  "Courses about war, diplomacy, and international security",
  "How do markets, inequality, and public policy interact?",
  "Classes about film, media, and modern culture",
  "Courses on storytelling, memory, and identity",
  "Mathy classes about probability, risk, and uncertainty",
  "Classes for technical founders interested in entrepreneurship",
  "Courses about sustainable architecture and urban design",
  "I want to study language, cognition, and how the mind works",
  "Classes about oceans, weather, and environmental systems",
  "Courses that explain why people vote and how democracies change",
  "History of empires, colonialism, and global power",
  "Classes about machine learning in healthcare",
  "Courses for pre-med students interested in ethics and society",
  "Famous explorers",
  "What is the meaning of life? 🤔",
  "How to make rockets go brrrrr",
  "🖌️🎨🧑‍🎨",
  "💃🕺🎶",
  "🤖🦾🦿",
  "🧬🧫🧪",
  "🪐🌎🌌",
  "How can we solve climate change?",
  "Science and technology in ancient civilizations",
  "How can we become a multiplanetary species?",
  "Are we alone in the universe?",
  "What makes water wet",
  "Basics of weightlifting",
  "Synthetic biology",
  "CS 3130",
  "ENWR 1510",
  "Interplay between science and religion",
  "Why does capitalism work?",
  "DS 3005",
  "RUTR 3360",
  "PHIL 1330",
  "What are the underlying principles of democracy",
  "Literature from across the world",
  "ASTR 3450",
  "CS 4710",
  "JPTR 3400",
  "David Kittlesen",
  "Lisa Morkowchuk",
  "Abby Fines",
  "Ann Massey",
  "Maksim Bychkov",
  "Jason Chruma",
  "Gretchen Martinet",
  "Charity Nyelele",
  "Gwendolyn Lewis",
  "Justin Kirkland",
  "Michelle Personick",
  "Homa Alemzadeh",
  "Kevin Welch",
  "Miaomiao Zhang",
  "Afsaneh Doryab",
  "Jundong Li",
  "Mark Sherriff",
  "How has education changed over time?",
  "The history of science",
  "Art of the renaissance era",
  "The Roman Empire",
  "GETR 3790"
];

export default SampleSearches;
